module.exports = __webpack_public_path__ + "fonts/SFProDisplay-Medium.c850c91d.ttf";